module.exports = __webpack_public_path__ + "static/media/video-14-ru.40b5acd1.webm";